/* SS 14.09.2026 - price-history pill, see assets/ss-pdp-pills.css.
   The Compliance Tracker app fills its <a class="price-history-trigger"> with
   "Høyest til lavest pris siste 90 dager: 599 kr - 499 kr" (or "Høyest og lavest pris siste 90 dager: 599 kr")
   after fetching /apps/compliance, and again on variant change. We shorten it to "<label>: <lowest price><suffix>",
   e.g. "Siste 90 dager: 499 kr", and keep the full sentence as the title attribute. Label and suffix come from data
   attributes on .ss-price-pill (set in Liquid) so other stores can translate. */
(function () {
  'use strict';
  function toNumber(s) {
    s = s.replace(/[^\d.,]/g, '');
    var dec = s.match(/[.,](\d{1,2})$/);            // "599,00" / "599.5" -> decimals
    var whole = dec ? s.slice(0, dec.index) : s;   // "1 299" / "1.299" -> thousands
    var n = parseFloat(whole.replace(/[.,]/g, '') + (dec ? '.' + dec[1] : ''));
    return isNaN(n) ? null : n;
  }
  function format(n) {
    var whole = Math.floor(n), frac = Math.round((n - whole) * 100);
    var s = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return frac ? s + ',' + (frac < 10 ? '0' : '') + frac : s;
  }
  function shorten(wrap) {
    var a = wrap.querySelector('.price-history-trigger');
    if (!a) return;
    var label = wrap.getAttribute('data-ss-pill-label') || 'Siste 90 dager';
    var suffix = wrap.getAttribute('data-ss-pill-suffix') || ' kr';
    var text = (a.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text || text.indexOf(label + ':') === 0) return;   // empty, or already ours
    var i = text.indexOf(':');
    if (i < 0) return;
    var nums = (text.slice(i + 1).match(/\d[\d\s.,]*/g) || []).map(toNumber).filter(function (n) { return n !== null; });
    if (!nums.length) return;
    a.textContent = label + ': ' + format(Math.min.apply(null, nums)) + suffix;
    a.setAttribute('title', text);
    a.setAttribute('data-ss-ready', '1');
  }
  function watch(wrap) {
    shorten(wrap);
    new MutationObserver(function () { shorten(wrap); })
      .observe(wrap, { childList: true, subtree: true, characterData: true });
  }
  function init() {
    var wraps = document.querySelectorAll('.ss-price-pill');
    for (var k = 0; k < wraps.length; k++) watch(wraps[k]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
